import { Link } from "@inertiajs/react";

export default function DashboardIndex({ auth }) {
  return (
    <main className="min-h-screen bg-black px-6 py-10 text-white sm:px-8 lg:px-10">
      <div className="mx-auto max-w-5xl">
        <div className="rounded-3xl border border-slate-800 bg-slate-950/90 p-8 shadow-[0_24px_70px_rgba(2,6,23,.55)]">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-cyan-300">Admin Area</p>
          <h1 className="mt-3 text-4xl font-semibold tracking-tight">Signed In</h1>
          <p className="mt-4 max-w-2xl text-base leading-7 text-slate-300">
            Your Devise session is active. This is a temporary internal area while the rest of the original application is being imported into Rails.
          </p>

          <section className="mt-8 rounded-2xl border border-cyan-400/25 bg-cyan-500/10 p-5">
            <p className="text-sm font-semibold text-cyan-100">Authenticated user</p>
            <div className="mt-4 space-y-2 text-sm text-cyan-50">
              <p>
                <span className="text-cyan-200/80">Name:</span> {auth?.name || "Superadmin"}
              </p>
              <p>
                <span className="text-cyan-200/80">Email:</span> {auth?.email}
              </p>
            </div>
          </section>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              href="/"
              className="rounded-xl border border-slate-700 bg-slate-900 px-5 py-2.5 text-sm font-semibold text-white transition hover:border-slate-500 hover:bg-slate-800"
            >
              Back to home
            </Link>
            <Link
              href="/users/sign_out"
              method="delete"
              as="button"
              className="rounded-xl bg-white px-5 py-2.5 text-sm font-semibold text-black transition hover:bg-slate-200"
            >
              Logout
            </Link>
          </div>
        </div>
      </div>
    </main>
  );
}
